import {req, reqJson} from './axiosFun';

/**
 * 提现申请管理
 **/
//查询
export const queryExtractPage = (params) => {
  return reqJson("post", "/api/commission/queryExtractPageByAdmin", params)
};
//审核
export const auditExtract = (params) => {
  return reqJson("post", "/api/commission/auditExtract", params)
};
//撤销
export const cancelExtract = (id) => {
  return reqJson("post", "/api/commission/cancelExtract/" + id)
};
//刷新
export const refreshExtract = (id) => {
  return reqJson("post", "/api/commission/refreshExtract/" + id)
};



// WEBPACK FOOTER //
// ./src/api/commissionExtractMG.js